<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="upcs"
      :search="filter"
      class="my-1 levation-2 myDense"
      :pagination.sync="pagination"
      select-all
      v-model="selectedUpcs"
      :rows-per-page-items="rowPerPage"
      item-key="upc"
    >
      <template v-slot:items="props">
        <tr :class="props.item.unstowedQty < 0 ? 'abnormal_list' : ''">
          <td @click.stop="onClickItem(props)">
            <v-checkbox
              v-if="props.item.unstowedQty || type === 'pickup'"
              :input-value="props.selected"
              primary
              hide-details
            ></v-checkbox>
          </td>
          <td class="subheading">
            <v-layout class="text-sm-left">
                {{ props.item.upc }}
              <v-tooltip top v-if="props.item.isPackageManagement">
                <template v-slot:activator="data">
                  <div v-on="data.on"><v-icon class="ml-1">widgets</v-icon></div>
                </template>
                <span>{{ $t('isThePackage') }}</span>
              </v-tooltip>
            </v-layout>
          </td>
          <td class="text-xs-left">{{ props.item.productName }}</td>
          <td class="text-xs-left" v-if="type === 'stow'">{{ props.item.unstowedQty }} / {{ props.item.totalQty }}</td>
          <td class="text-xs-left" v-else>{{ props.item.totalQty }}</td>
          <td class="text-xs-left">
            {{ props.item.location.join(', ') }}
          </td>
          <td class="text-xs-right" v-if="type === 'stow'">
            <v-layout row justify-center align-baseline>
              <v-flex xs3 v-if="props.selected">
                <v-text-field
                  class="table-item"
                  v-model.number="stowMap[props.item.upc]"
                  hide-details
                  mask="#####"></v-text-field>
              </v-flex>
              <v-flex xs6><v-btn dark color="primary" flat @click.stop="$$showEditLocationDialog(props.item)">{{ $t('edit') }}</v-btn></v-flex>
            </v-layout>
          </td>
        </tr>
      </template>
    </v-data-table>
    <FormSubmitPopup
      hasAlert
      :title="$t('editLocation')"
      v-model="editLocationDialog"
      :rightMethod="editLocation"
      @popupClose="() => { editLocationDialog = false }"
      medium
    >
      <template v-slot:input>
        <v-alert
          v-model="hasMessage"
          dismissible
          type="success">{{ submitMessage }}</v-alert>

        <v-layout>{{`${$t('siteName')}: ${getSiteNameFromKey(siteKey)}`}}</v-layout>
        <v-layout>
          <v-flex>
            <v-text-field
              label="UPC"
              class="required_field"
              v-model="upcInEdit.upc"
              @change="onUpdateUpc"
              id="upc"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>{{`${$t('productName')}: ${upcInEdit.productName || 'N/A'}`}}</v-layout>
        <v-layout>
          <v-flex>
            <v-combobox
              v-model="upcInEdit.location"
              chips
              multiple
              deletable-chips
              clearable
              ref="combobox"
            ></v-combobox>
          </v-flex>
        </v-layout>
      </template>
    </FormSubmitPopup>
  </div>
</template>

<script>
import { deepEqual } from '@/utils/tools'
import FormSubmitPopup from './FormSubmitPopup'

export default {
  name: 'WarehouseStowTable',
  components: {
    FormSubmitPopup
  },
  data () {
    return {
      headers: this.type === 'stow' ? [
        { text: this.$t('upc'), value: 'upc', align: 'left', sortable: false },
        { text: this.$t('productName'), value: '', align: 'left', sortable: false },
        { text: `${this.$t('unStowed')} / ${this.$t('totalQty')}`, value: '', align: 'left', sortable: true },
        { text: this.$t('location'), value: 'location', align: 'left', sortable: true },
        { text: `(${this.$t('stowQty')}) / ${this.$t('actions')}`, value: '', align: 'center', sortable: false, width: '20%' }
      ] : [
        { text: this.$t('upc'), value: 'upc', align: 'left', sortable: false },
        { text: this.$t('productName'), value: '', align: 'left', sortable: false },
        { text: this.$t('quantity'), value: '', align: 'left', sortable: true },
        { text: this.$t('location'), value: 'location', align: 'left', sortable: true }
      ],
      editLocationDialog: false,
      upcInEdit: {},
      initLocation: [],
      rowPerPage: [15, 30, 50, {text: this.$t('all'), value: -1}],
      pagination: {
        sortBy: 'upc'
      },
      selectedUpcs: [],
      stowMap: {},
      hasMessage: false,
      submitMessage: ''
    }
  },
  computed: {
    upcs () {
      return [...this.upcToQtyMap].map(([upc, {totalQty, unstowedQty, isPackageManagement}]) => {
        let location = []
        const item = this.upcMap[upc]
        if (item && item.location) {
          location = ((item.location || []).find(item => item.siteKey === this.siteKey) || {}).location || []
        } 
        return {
          upc,
          productName: this.upcMap[upc] ? this.upcMap[upc].description : 'new product',
          totalQty,
          unstowedQty,
          location,
          isPackageManagement
        }
      })
    },
    upcMap () {
      return this.$store.getters.upcMap
    },
    warehousesSites () {
      return this.$store.getters.warehousesSites
    }
  },
  watch: {
    upcToQtyMap () {
      this.selectedUpcs = []
      this.stowMap = {}
    },
    selectedUpcs: {
      handler: function (value) {
        value.forEach(item => {
          this.stowMap[item.upc] = this.stowMap[item.upc] === undefined ? item.unstowedQty : this.stowMap[item.upc]
        })
        this.$emit('update:selectedUpcs', value)
      },
      immediate: true,
      deep: true
    },
    editLocationDialog () {
      this.hasMessage = false
    }
  },
  methods: {
    onClickItem (props) {
      props.selected = !props.selected
      if (props.selected) {
        this.stowMap[props.item.upc] = props.item.unstowedQty || 0
      }
    },
    $$showEditLocationDialog (item = {}) {
      this.editLocationDialog = true
      this.upcInEdit = {...item}
      this.initLocation = [...(item.location || [])]
    },
    editLocation () {
      this.hasMessage = false
      if (!this.upcMap[this.upcInEdit.upc]) throw Error('Can not find upc.')
      if (!deepEqual(((this.upcMap[this.upcInEdit.upc].location || []).find(item => item.siteKey === this.siteKey) || {}).location, this.initLocation)) {
        if (!confirm(this.$t('editLocationWarning'))) {
          return Promise.resolve('keepPopup')
        } 
      }
      return this.$store.dispatch('updateUpc', {
        key: this.upcMap[this.upcInEdit.upc].key,
        upc: this.upcInEdit.upc,
        location: this.upcInEdit.location || [],
        siteKey: this.siteKey
      })
        .then(() => {
          this.hasMessage = true
          this.submitMessage = this.$t('editLocationMessage', { upc: this.upcInEdit.upc })
          document.getElementById('upc').select()
          return 'keepPopup'
        })
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    getSiteNameFromKey (siteKey) {
      return (this.warehousesSites.find(ele => ele.key === siteKey) || {}).siteName
    },
    onUpdateUpc (upc) {
      upc = upc.trim()
      let target = this.upcMap[upc]
      if (target) {
        const {location, description: productName} = target
        this.$set(this.upcInEdit, 'location', (location.find(item => item.siteKey === this.siteKey) || {}).location || [])
        this.$set(this.upcInEdit, 'productName', productName)
        this.initLocation = (location.find(item => item.siteKey === this.siteKey) || {}).location || []
        this.$refs.combobox.focus()
      } else if (upc) {
        alert(`Can not find upc: ${upc}.`)
        document.getElementById('upc').select()
      }
    }
  },
  props: {
    upcToQtyMap: {
      type: Map,
      default: () => {
        return new Map()
      }
    },
    siteKey: String,
    type: String,
    filter: String
  }
}
</script>

<style scoped>
.table-item {
  padding: 0;
  margin: 0;
}
.abnormal_list {
  background-color: yellow
}
</style>



// WEBPACK FOOTER //
// src/components/WarehouseStowTable.vue